import { render, staticRenderFns } from "./DesignsPageContainer.vue?vue&type=template&id=4a5d7534&"
import script from "./DesignsPageContainer.vue?vue&type=script&lang=js&"
export * from "./DesignsPageContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports